import { bound } from "@frui.ts/helpers";
import type { IBindingProps } from "@frui.ts/views";
import { BindingComponent } from "@frui.ts/views";
import { Observer } from "mobx-react-lite";
import React from "react";
import type { FormProps } from "react-bootstrap";
import { Form } from "react-bootstrap";
import type { ColProps } from "react-bootstrap/Col";
import type { BsPrefixAndClassNameOnlyProps } from "react-bootstrap/helpers";

export interface BsPrefixProps<As extends React.ElementType = React.ElementType> extends BsPrefixAndClassNameOnlyProps {
  as?: As;
}

export class FormGroup<TTarget, As extends React.ElementType = React.ElementType> extends BindingComponent<
  TTarget,
  IBindingProps<TTarget> & FormProps & ColProps & BsPrefixProps<As>
> {
  @bound
  protected renderInner() {
    const { children, ...props } = this.props;
    const { target, property, ...rest } = props as { target: TTarget; property: keyof TTarget & string };

    const childrenWithBindingProps = React.Children.map(children, child => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { target, property });
      }
      return child;
    });

    return (
      <Form.Group controlId={property} {...rest}>
        {childrenWithBindingProps}
      </Form.Group>
    );
  }

  render() {
    return <Observer render={this.renderInner} />;
  }
}

export default FormGroup;
